import React from 'react'

import { colors } from 'src/assets/colors'
import styled from 'styled-components'

type Props = {
  message: string
}

export const Authenticate: React.FC<Props> = ({ message }) => {
  return (
    <PageContainer>
      <ContentContainer>
        <Text>{message}</Text>
      </ContentContainer>
    </PageContainer>
  )
}

const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${colors.bgGray};
`

const ContentContainer = styled.div`
  width: 100%;
  max-width: 1024px;
  margin: 80px;
  padding: 40px 40px;

  display: flex;
  flex-direction: column;
  align-items: center;

  background: #ffffff;
  box-shadow: 0px 10px 30px rgba(133, 141, 168, 0.06);
  border-radius: 10px;
`

const Text = styled.p`
  width: 100%;
  margin: 0;
  text-align: center;
  color: ${colors.dark};
  font-size: 20px;
  line-height: 36px;
  font-weight: bold;
`
